import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import testImg from "../../../../Assets/img/test-img.png";
import Loader from "../../../Components/Loader/Loader";
import {
  errorMessage,
  getSetResults,
} from "../../../../Features/LKWBTestApi/LKWBTestApi";

const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};

// writing_status looks like { graded: 2 } or { pending: 1, graded: 1 }.
const writingText = (status) =>
  status && typeof status === "object"
    ? Object.entries(status)
        .filter(([, count]) => count)
        .map(([state, count]) => `${count} ${state}`)
        .join(", ")
    : "";

// Past attempts of one LKWB set, newest first.
const LKWBTestResults = () => {
  const { id, setId } = useParams();
  const token = useSelector((state) => state.auth.currentUser.token);
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    getSetResults(setId, token)
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? [...data] : [];
        list.sort(
          (a, b) => new Date(b.submitted_at) - new Date(a.submitted_at)
        );
        setResults(list);
        setError("");
      })
      .catch((err) => {
        if (!cancelled) setError(errorMessage(err, "Unable to load results."));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [setId, token]);

  if (isLoading) {
    return (
      <div className="loading__mode bigLoading">
        <Loader />
      </div>
    );
  }

  const best = results.reduce(
    (max, r) => Math.max(max, Number(r.total_obtained_marks) || 0),
    0
  );

  return (
    <Row>
      <Col md={9}>
        <div className="dashboard-contents dashboard-test">
          <Link to={`/dashboard/lkwb-test/${id}`} className="btn btn-small">
            Go Back
          </Link>
          <div className="dashboard-contentshead">
            <img src={testImg} alt="" />
            <div className="packageName">
              <h3 className="eachdashboard-title">
                {results[0]?.set || "Results"}
              </h3>
              <p className="lkwb-meta">
                {results.length} {results.length === 1 ? "Attempt" : "Attempts"}
                {results.length > 0 &&
                  ` · Best ${best} / ${results[0].total_marks}`}
              </p>
            </div>
          </div>

          <div className="eachdashboard-detail">
            <h3 className="eachdashboard-title lkwb-sets-title">Results</h3>
            {error ? (
              <div className="youhavenot-container">
                <p>{error}</p>
              </div>
            ) : results.length === 0 ? (
              <div className="youhavenot-container">
                <p>You have not taken this test yet.</p>
              </div>
            ) : (
              <div className="setstitem-container lkwb-list">
                {results.map((r, i) => (
                  <div
                    key={r.result_id}
                    className="normalsetsitem setsitem-container lkwb-card item-notbought"
                  >
                    <div className="setsitem-header">
                      <div className="pdficon">
                        <img src={testImg} alt="" />
                        <div className="sets-content">
                          <div>
                            <h5>
                              Attempt {results.length - i}
                              {r.exam_id && ` · ${r.exam_id}`}
                            </h5>
                            <p className="lkwb-meta">
                              {[
                                formatDate(r.submitted_at),
                                writingText(r.writing_status) &&
                                  `Writing: ${writingText(r.writing_status)}`,
                              ]
                                .filter(Boolean)
                                .join(" · ")}
                            </p>
                          </div>
                          <div className="text-end lkwb-result-score">
                            <strong>
                              {r.total_obtained_marks ?? r.score ?? 0}
                            </strong>
                            <span> / {r.total_marks}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <Link
          to={`/dashboard/lkwb-test/${id}/sets/${setId}/buy`}
          className="btn mt-3"
        >
          Take Test Again
        </Link>
      </Col>
      <Col md={3} className="rightsidebar"></Col>
    </Row>
  );
};

export default LKWBTestResults;
